import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Layouts/Sidebar";
import Header from "./Layouts/Header";
import InternSidebar from "../InternManagement/Layouts/InternSidebar";
import './Dashboard.css';

export default function AdminDashboard() {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Check if we're on an intern management route
  const isInternManagementRoute = location.pathname.includes('intern') || 
    location.pathname.includes('task-board') ||
    location.pathname.includes('daily-logs') ||
    location.pathname.includes('feedback-management') ||
    location.pathname.includes('file-management');

  console.log('DEBUG [AdminDashboard]:', {
    path: location.pathname,
    isInternRoute: isInternManagementRoute,
    host: window.location.host
  });

  return (
    <div className="admin-dashboard-wrapper admin-db1" style={{ display: 'flex', height: '100vh', overflow: 'hidden', width: '100vw' }}>
      {/* Conditional Sidebar */}
      {isInternManagementRoute ? (
        <InternSidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
      ) : (
        <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
      )}

      {/* Right Section */}
      <div className="db1-bg" style={{
        marginLeft: windowWidth >= 768 ? '250px' : '0',
        width: windowWidth >= 768 ? 'calc(100vw - 250px)' : '100vw',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        transition: 'margin-left 0.3s ease-in-out, width 0.3s ease-in-out',
        overflow: 'hidden'
      }}>
        <Header toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} isSidebarOpen={isSidebarOpen} />
        <div style={{ flex: 1, overflowY: 'auto', padding: '0', position: 'relative', zIndex: 1 }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
